// extracted by mini-css-extract-plugin
module.exports = {"margin-bottom20px":"style_margin-bottom20px__2g-_f"};